<div>
  <table class="uk-table uk-table-striped mt-23">
    <tr>
      <th style="width: 25%; text-align: center">
        {{'date' | translate}}
      </th>
      <th>
        {{'status' | translate}}
      </th>
    </tr>
    <tr *ngFor="let row of history" [hidden]="'pl' !== language && null === row.name_ro">
      <td style="text-align: center">
        <kbd>{{row.when}}</kbd>
      </td>
      <td>
        {{'pl' === language ? row.name : row.name_ro}}
        <button
          *ngIf="row.deletion_allowed && isAdmin"
          id="delete_status_button"
          class="uk-button padding-horizontal-small"
          (click)="delete(row.id)"
        >
          <span uk-icon="trash"></span>
        </button>

        <small *ngIf="null !== row.user"><br>{{ row.user }}</small>
        <small *ngIf="null !== row.workstation"><br>{{ row.workstation }}</small>
        <small *ngIf="null !== row.problematic_sector" class="uk-text-danger"><br>{{ row.problematic_sector.name }}</small>

      </td>
    </tr>
  </table>
</div>
